import React from "react";
import PropTypes from "prop-types";
import {
  AvgResponseTimeWrapper,
  AvgResponseTimeHeader,
  AvgResponseTimeContent,
} from "./styles/avg-response-time-styles";

const AvgResponseTime = ({ avgResponseTime }) => (
  <AvgResponseTimeWrapper>
    <AvgResponseTimeHeader>Average Response Time</AvgResponseTimeHeader>
    <AvgResponseTimeContent>
      {avgResponseTime || "new employer"}
    </AvgResponseTimeContent>
  </AvgResponseTimeWrapper>
);

AvgResponseTime.propTypes = {
  avgResponseTime: PropTypes.string,
};

AvgResponseTime.defaultProps = {
  avgResponseTime: PropTypes.isNull,
};

export default React.memo(AvgResponseTime);
